import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { appStore, googlePlay } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="13px" column center>
          <CFView h3 futura bold color="#C60000" mb="20px">
            DOWNLOAD APP
          </CFView>
          <CFView column center white bold>
            <CFView h5 mb="15px" textCenter maxWidth="75vw">
              Ton Ton Sushi is now taking online orders. Order through our
              website or download our app in your app store!
            </CFView>
            <CFView row center>
              <CFView mr="10px">
                <CFLink href="https://apps.apple.com/nz/app/sushi-tonton/id1593513951">
                  <CFImage
                    h="40px"
                    src={appStore}
                    alt="Ton Ton Sushi App Store"
                  />
                </CFLink>
              </CFView>
              <CFLink href="https://play.google.com/store/apps/details?id=tech.codefusion.tonton">
                <CFImage
                  h="40px"
                  src={googlePlay}
                  alt="Ton Ton Sushi Google Play"
                />
              </CFLink>
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mr="25px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="20px" minWidth="180px">
            DOWNLOAD APP
          </CFView>
          <CFView column justifyStart white bold>
            <CFView
              maxWidth="260px"
              fontSize="16px"
              mb="15px"
              style={{ lineHeight: '22px' }}
            >
              Ton Ton Sushi is now taking online orders. Order through our
              website or download our app in your app store!
            </CFView>
            <CFLink href="https://apps.apple.com/nz/app/sushi-tonton/id1593513951">
              <CFImage
                h="37px"
                mt="5px"
                src={appStore}
                alt="Ton Ton Sushi App Store"
                hover
              />
            </CFLink>
            <CFLink href="https://play.google.com/store/apps/details?id=tech.codefusion.tonton">
              <CFImage
                h="37px"
                mt="5px"
                src={googlePlay}
                alt="Ton Ton Sushi Google Play"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
